require.register("app/product/stat/OrderCountView", function(exports, require, module){
  $0
  
});

